export default "__VITE_ASSET__Bdn_69ln__"